import { useState } from "react";

import { dispatch } from "../../state/store";
import { pushCreatedTableRowsIds, setFWUVersionsRefresh } from "../../state/ducks";

import { strCode } from "../../consts";
import { fwuVersionsService, log, notificationService, t } from "../../services";

export const uploadFWUFile = async (url, file) => {
  try {
    await fwuVersionsService.uploadFile(url, file);
  } catch (error) {
    log.error("useCreateFWUVersion: Failed to upload FWU file", error);

    notificationService.showError({
      title: t(strCode.UPLOAD_FWU_FILE_ERROR),
      message: error?.response?.data?.message ? error.response.data.message : error?.toString()
    });
  }
};

export const useCreateFWUVersion = () => {
  const [loading, setLoading] = useState(false);

  const mutationCallback = async (newFirmware, binFile, signatureFile) => {
    try {
      setLoading(true);

      const res = await fwuVersionsService.createFWUVersion(newFirmware);

      const binFileUrl = res?.data?.data?.bin_file_url;
      const signatureFileUrl = res?.data?.data?.signature_file_url;

      if (binFileUrl && signatureFileUrl) {
        await uploadFWUFile(binFileUrl, binFile);
        await uploadFWUFile(signatureFileUrl, signatureFile);
      }

      notificationService.showSuccess({
        title: t(strCode.CREATE_FWU_VERSION_SUCCESS),
        message: t(strCode.CREATE_FWU_VERSION_SUCCESS_INFO)
      });

      dispatch(pushCreatedTableRowsIds([newFirmware?.version]));
      dispatch(setFWUVersionsRefresh(true));
    } catch (error) {
      log.error("useCreateFWUVersion: Failed to create FWU version", error);
      notificationService.showError({
        title: t(strCode.CREATE_FWU_VERSION_ERROR),
        message: error?.response?.data?.message ? error.response.data.message : error?.toString()
      });
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return { mutationCallback, loading };
};
